import Timeline from './Timeline'

export { TimelineProps } from './Timeline'
export { TimeLineItemProps } from './TimelineItem'
import TimelineItem from './TimelineItem'

Timeline.Item = TimelineItem

export default Timeline



// WEBPACK FOOTER //
// ./components/timeline/index.jsx